import React from 'react';
import OldSystemMessagesSettingsSection from '../../../../configure/panels/sections/SystemMessagesSettingsSection/SystemMessagesSettingsSection';

export const SystemMessages = () => {
  return <OldSystemMessagesSettingsSection />;
};
